import React from 'react';
import { Button } from '@/components/atoms/PcButton';
import { useNavigate } from 'react-router-dom';
import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';
import { cn } from '@/utils/tailwind';

const NotRegisteredState = ({ className }: { className?: string }) => {
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center gap-[20px]',
        className,
      )}
    >
      <EmptyFaceIcon />
      <div className="text-gr-700 Body1S16">연동된 마켓이 없어요</div>
      <Button variant="muted" className="w-fit" onClick={() => navigate('/market')}>
        마켓 연동하기
      </Button>
    </div>
  );
};

export default NotRegisteredState;
